module.exports = __webpack_public_path__ + "media/images/deep_link/pencil-4b520c5ac9aa05f5ccbff5c67aaa30b7.svg";